import script from "./EditPopupEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditPopupEvent.vue?vue&type=script&setup=true&lang=ts"

import "./EditPopupEvent.vue?vue&type=style&index=0&id=69b1a910&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69b1a910"]])

export default __exports__